import type { ReactNode } from "react";

interface CardListGroupProps {
  date: string;
  children: ReactNode;
}

export const CardListGroup = ({ date, children }: CardListGroupProps) => (
  <div className="space-y-1">
    <p className="text-xs font-light text-muted-foreground">{date}</p>
    {children}
  </div>
);
